<!--В каждом контейнере создаёт кнопки с названиями городов,
по их клику отправляется автобус в main-page с выбранным регионом-->
<template>
  <v-card>
    <v-card-title v-once primary-title>
      <div class="headline">
        <slot/>
      </div>
    </v-card-title>
    <v-card-text class="px-0" style="text-align: center">
      <v-btn style="margin: 4pt; padding: 4pt"
        v-for="region in regions"
        :key="region.id"
        @click="setRegion(region)"
        >
        {{ region.name }}
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import {bus} from "@/main";

export default {
  name: "RegionsSelectedOnceType",
  props: {
    regions: Array
  },
  methods: {
    setRegion(region) {
      bus.$emit('selectedMunicipality', region)
    }
  }
};
</script>

<style scoped></style>
